import Button from "components/buttons/Button";
import InputButton from "components/buttons/InputButton";
import { authService, myFirebase } from "myfirebase";
import React, { useEffect, useState } from "react";

const Auth = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "Create Account or Sign In | Atrable";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newAccount, setNewAccount] = useState(true);
  const [error, setError] = useState("");

  const onChange = (event) => {
    const {
      target: { name, value },
    } = event;
    if (name === "email") {
      setEmail(value);
    } else if (name === "password") {
      setPassword(value);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      if (newAccount) {
        await authService.createUserWithEmailAndPassword(email, password);
        await authService.currentUser.sendEmailVerification();
      } else {
        await authService.signInWithEmailAndPassword(email, password);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  const toggleAccount = () => setNewAccount((prev) => !prev);

  const GoogleSignUp = async () => {
    let provider;
    provider = new myFirebase.auth.GoogleAuthProvider();
    await authService
      .signInWithPopup(provider)
      .then((result) => {})
      .catch((error) => {
        alert(error.message);
      });
  };

  const textfieldstyle = {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "30px",
    width: "90%",
    maxWidth: "750px",
    minWidth: "100px",
    padding: "15px",
    borderRadius: "11.25px",
    border: "none",
    backgroundColor: "white",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          backgroundColor: "whitesmoke",
          textAlign: "center",
          width: "75%",
          maxWidth: "800px",
          minWidth: "200px",
          margin: "auto",
          padding: "30px",
          borderRadius: "15px",
          marginTop: "50px",
        }}
      >
        <h1 style={{ marginBottom: "90px" }}>
          {newAccount ? "Create Account" : "Sign in"}
        </h1>
        <form onSubmit={onSubmit}>
          <input
            name="email"
            type="text"
            placeholder="Email"
            required
            value={email}
            onChange={onChange}
            style={textfieldstyle}
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            required
            value={password}
            onChange={onChange}
            style={textfieldstyle}
          />
          <div style={{ color: "#ff5f52" }}>{error}</div>
          <div style={{ height: 60 }} />
          <InputButton
            value={newAccount ? "Create Account" : "Sign In"}
            width="calc(90% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            backgroundColor="#1877f3"
            color="white"
            zoom
          ></InputButton>
          <div style={{ height: "15px" }} />
          <Button
            onClick={toggleAccount}
            width="calc(90% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            backgroundColor="white"
            color="#1877f3"
            zoom
          >
            {newAccount ? "or Sign In" : "or Create Account"}
          </Button>
        </form>
      </div>
      <div
        style={{
          width: "75%",
          maxWidth: "800px",
          minWidth: "200px",
          margin: "auto",
          paddingTop: 15,
          paddingBottom: 15,
        }}
      >
        <Button width="100%" backgroundColor="whitesmoke" color="#1877f3" zoom onClick={GoogleSignUp}>
          <div style={{ display: "flex" }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"
              style={{
                padding: "5px",
                borderRadius: "5px",
              }}
              height="30px"
              alt="Google logo"
            ></img>
            <span style={{ paddingRight: "15px", margin: "auto" }}>
              Continue with Google
            </span>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"
              style={{
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "5px",
                visibility: "hidden",
              }}
              height="30px"
              alt="Google logo"
            ></img>
          </div>
        </Button>
      </div>
      <div style={{ height: 90 }} />
    </div>
  );
};
export default Auth;
